import {
  StandardTableConfigWithNoGroups,
  createColumnConfig,
} from "@stenajs-webui/grid";
import { formatAmountWithCurrency } from "../lib/rebateAmountUtils";
import { RouteReservedBookings } from "../lib/reservedBookingUtils";

export type RebateBookingsSummaryColumnKeys = "route" | "bookings" | "reserved";

/**
 * Mirrors what the collapsed route cards show: route code, booking count and
 * total reserved. Used by the copy-to-clipboard button so a paste matches the
 * on-screen summary rather than every booking row.
 */
export const createRebateBookingsSummaryTableConfig = (
  currencyCode: string | null | undefined
): StandardTableConfigWithNoGroups<
  RouteReservedBookings,
  RebateBookingsSummaryColumnKeys
> => ({
  keyResolver: (item) => item.routeCode,
  disableInfiniteList: true,
  columns: {
    route: createColumnConfig((item) => item.routeCode, {
      columnLabel: "Route",
    }),
    bookings: createColumnConfig((item) => item.bookings.length, {
      columnLabel: "Bookings",
    }),
    reserved: createColumnConfig(
      (item) => formatAmountWithCurrency(item.totalReserved, currencyCode),
      { columnLabel: "Reserved" }
    ),
  },
  columnOrder: ["route", "bookings", "reserved"],
});
